import React, { useState } from "react";

import { PropTypes } from "prop-types";

import {
  Typography,
  Card,
  Stack,
  IconButton,
  Grid,
  Tooltip,
} from "@mui/material";

import Checkbox from "../../../react_utils/fields/Checkbox";
import InfoTooltip from "../../../react_utils/InfoTooltip";
import HeatpumpNameModal from "./HeatpumpNameModal";
import Icon from "../../../react_utils/Icon";
import HeatpumpSgReadyTimeModal from "./HeatpumpSgReadyTimeModal";
import HeatpumpSgReadySocModal from "./HeatpumpSgReadySocModal";
import {
  heatpumpSgReadySocSettings,
  sgReadyHelp,
  sgReadyTitle,
} from "../../../shared/constants/heatpump";

const cardWidth = 300;
const cardHeight = 150;

export default function HeatpumpCard({
  heatpump,
  setSgReady,
  editName,
  setSgReadyTime,
  setSgReadySoc,
  infoText = true,
}) {
  const [hovered, setHovered] = useState(false);

  const getOpenSgReadyTimeButton = (toggle) => {
    return (
      <Tooltip
        title={
          <Typography sx={{ fontSize: 14 }}>
            Schaltzeiten für SG-Ready einschränken
          </Typography>
        }
        enterTouchDelay={0}
      >
        <IconButton
          disableFocusRipple
          disableRipple
          style={{ backgroundColor: "transparent" }}
          onClick={toggle}
        >
          <Icon icon={"clock"} color="secondary" />
        </IconButton>
      </Tooltip>
    );
  };

  const getOpenSgReadySocButton = (toggle) => {
    return (
      <Tooltip
        title={
          <Typography sx={{ fontSize: 14 }}>
            {heatpumpSgReadySocSettings}
          </Typography>
        }
        enterTouchDelay={0}
      >
        <IconButton
          disableFocusRipple
          disableRipple
          style={{ backgroundColor: "transparent" }}
          onClick={toggle}
        >
          <Icon icon={"battery"} color="secondary" />
        </IconButton>
      </Tooltip>
    );
  };

  const heatpumpSetPoint = heatpump._set_point;
  if (!heatpumpSetPoint) return null;

  return (
    <Card
      key={`heatpumpsetpoint-${heatpump.id}`}
      sx={{
        minWidth: cardWidth,
        minHeight: cardHeight,
        padding: "10px",
        backgroundColor: "tertiary.main",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Grid container justify="center">
        <Grid
          xs={6}
          sm={6}
          md={6}
          item
          style={{ display: "flex", alignItems: "center" }}
        >
          <Stack direction="row" spacing={1}>
            <Typography color="secondary" variant="h6">
              Wärmepumpe
            </Typography>
            {editName && (
              <HeatpumpNameModal
                heatpump={heatpump}
                editName={editName}
                modalProps={{
                  getOpenButton: (toggle) =>
                    hovered && (
                      <IconButton
                        sx={{ p: 0 }}
                        disableFocusRipple
                        disableRipple
                        style={{ backgroundColor: "transparent" }}
                        onClick={toggle}
                      >
                        <Icon
                          icon={"edit"}
                          sx={{ color: "secondary.main" }}
                          fontSize="small"
                        />
                      </IconButton>
                    ),
                }}
              />
            )}
          </Stack>
        </Grid>
        {(setSgReadyTime || setSgReadySoc) && (
          <Grid
            xs={6}
            sm={6}
            md={6}
            item
            style={{ display: "flex" }}
            justifyContent={"flex-end"}
          >
            <Stack direction="row" spacing={0}>
              {setSgReadyTime && (
                <HeatpumpSgReadyTimeModal
                  heatpump={heatpump}
                  modalProps={{ getOpenButton: getOpenSgReadyTimeButton }}
                  setSgReadyTime={setSgReadyTime}
                />
              )}
              {setSgReadySoc && (
                <HeatpumpSgReadySocModal
                  heatpump={heatpump}
                  modalProps={{ getOpenButton: getOpenSgReadySocButton }}
                  setSgReadySoc={setSgReadySoc}
                />
              )}
            </Stack>
          </Grid>
        )}
      </Grid>
      <Checkbox
        checked={heatpumpSetPoint.sg_ready}
        onChange={(value) => {
          setSgReady && setSgReady(value);
        }}
        disabled={!setSgReady}
        label={
          <Typography>
            {sgReadyTitle}{" "}
            {infoText && <InfoTooltip>{sgReadyHelp}</InfoTooltip>}
          </Typography>
        }
      />
    </Card>
  );
}

HeatpumpCard.propTypes = {
  heatpump: PropTypes.object,
  editName: PropTypes.func,
  setSgReadyTime: PropTypes.func,
  setSgReadySoc: PropTypes.func,
  heatpumpSetPoint: PropTypes.object,
  setSgReady: PropTypes.func,
  infoText: PropTypes.bool,
};
